/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CommentsPaneLocal = {
    readonly commentID: string | null;
    readonly " $refType": "CommentsPaneLocal";
};
export type CommentsPaneLocal$data = CommentsPaneLocal;
export type CommentsPaneLocal$key = {
    readonly " $data"?: CommentsPaneLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentsPaneLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentsPaneLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentID",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '7082dfbf04097b9a1591ad1601ff8358';
export default node;
